import { images } from '../constants';

const services = [
  {
    id: 1,
    image: images.service1,
    title: 'Robotic Automation',
    content: 'Enhance efficiency with our cutting-edge robotic automation solutions designed to streamline your processes and reduce manual efforts.',
    paragraphs: [
      'Our robotic automation service integrates advanced robotics and AI technologies to automate repetitive and complex tasks, improving productivity and accuracy.',
      'We customize automation workflows tailored to your business needs, helping you achieve faster turnaround times, lower operational costs, and improved safety standards.'
    ],
    gallery: [
      images.service1Gallery1,
      images.service1Gallery2,
    ],
    features: [
      'Customizable Automation Solutions',
      'Advanced Robotics Integration',
      'Improved Operational Efficiency',
      'Reduced Human Error',
      '24/7 Monitoring & Support'
    ],
    procedure: [
      'Consultation & Needs Assessment',
      'Automation Design & Planning',
      'Robotic System Installation',
      'Testing & Quality Assurance',
      'Ongoing Maintenance & Support'
    ],
    faqs: [
      {
        id: 1,
        heading: 'What tasks can robotic automation handle?',
        content: 'Robotic automation can manage repetitive, hazardous, and precision tasks including assembly, packaging, inspection, and data processing.'
      },
      {
        id: 2,
        heading: 'How long does it take to implement robotic automation?',
        content: 'Implementation times vary by project complexity but typically range from a few weeks to several months.'
      },
      {
        id: 3,
        heading: 'Is robotic automation suitable for small businesses?',
        content: 'Yes, we offer scalable solutions that can be adapted for small to large enterprises, ensuring cost-effective automation.'
      },
      {
        id: 4,
        heading: 'Do you provide training and support?',
        content: 'Absolutely. We provide comprehensive training and 24/7 support to ensure smooth operation of your robotic systems.'
      }
    ]
  },
  {
    id: 2,
    image: images.service2,
    title: 'Data Analytics',
    content: 'Unlock powerful insights with our comprehensive data analytics solutions that drive informed decision-making and business growth.',
    paragraphs: [
      'Our data analytics service helps you collect, process, and analyze large volumes of data to reveal patterns, trends, and actionable insights.',
      'We utilize advanced analytical tools and machine learning techniques to provide predictive analytics, customer segmentation, and performance optimization tailored to your needs.'
    ],
    gallery: [
      images.service2Gallery1,
      images.service2Gallery2,
    ],
    features: [
      'Real-Time Data Processing',
      'Predictive & Prescriptive Analytics',
      'Custom Dashboard & Reporting',
      'Data-Driven Decision Support',
      'Secure & Scalable Solutions'
    ],
    procedure: [
      'Data Collection & Integration',
      'Data Cleaning & Preparation',
      'Analysis & Model Development',
      'Visualization & Reporting',
      'Continuous Monitoring & Optimization'
    ],
    faqs: [
      {
        id: 1,
        heading: 'What types of data can be analyzed?',
        content: 'We analyze various data types including customer behavior, sales, operations, social media, and sensor data.'
      },
      {
        id: 2,
        heading: 'How can data analytics improve my business?',
        content: 'Data analytics helps identify opportunities, optimize operations, forecast trends, and enhance customer engagement.'
      },
      {
        id: 3,
        heading: 'Is my data secure during analysis?',
        content: 'Yes, we prioritize data security with encryption, access controls, and compliance with industry standards.'
      },
      {
        id: 4,
        heading: 'Do you offer custom reports?',
        content: 'Absolutely, we tailor reports and dashboards to meet your specific business needs and goals.'
      }
    ]
  },
  {
    id: 3,
    image: images.service3,
    title: 'AI Application',
    content: 'Harness the power of artificial intelligence to automate processes, enhance customer experience, and innovate your business solutions.',
    paragraphs: [
      'Our AI Application service focuses on developing intelligent systems tailored to your business needs, including chatbots, recommendation engines, and predictive models.',
      'We integrate AI technologies like natural language processing, computer vision, and machine learning to create scalable and efficient applications that deliver measurable results.'
    ],
    gallery: [
      images.service3Gallery1,
      images.service3Gallery2,
    ],
    features: [
      'Custom AI Model Development',
      'Natural Language Processing',
      'Computer Vision Integration',
      'Automated Workflows',
      'Scalable AI Solutions'
    ],
    procedure: [
      'Consultation & Requirement Analysis',
      'AI Model Design & Training',
      'Application Development & Integration',
      'Testing & Quality Assurance',
      'Deployment & Ongoing Support'
    ],
    faqs: [
      {
        id: 1,
        heading: 'What types of AI applications do you build?',
        content: 'We develop chatbots, recommendation systems, image recognition apps, predictive analytics tools, and more.'
      },
      {
        id: 2,
        heading: 'How long does it take to develop an AI application?',
        content: 'Development time varies depending on complexity but typically ranges from a few weeks to several months.'
      },
      {
        id: 3,
        heading: 'Can AI applications integrate with existing systems?',
        content: 'Yes, we ensure seamless integration of AI solutions with your current software and workflows.'
      },
      {
        id: 4,
        heading: 'Do you provide support after deployment?',
        content: 'Absolutely, we offer ongoing maintenance, updates, and support to ensure your AI applications perform optimally.'
      }
    ]
  },
  {
    id: 4,
    image: images.service4,
    title: 'Security & Surveillance',
    content: 'Advanced security and surveillance solutions designed to protect your assets and ensure safety with real-time monitoring and intelligent analytics.',
    paragraphs: [
      'Our Security & Surveillance service offers state-of-the-art systems including CCTV, access control, and AI-powered video analytics to detect threats proactively.',
      'We customize security solutions to fit your business environment, providing peace of mind with 24/7 monitoring, alert systems, and data-driven insights.'
    ],
    gallery: [
      images.service4Gallery1,
      images.service4Gallery2,
    ],
    features: [
      'High-Definition CCTV Cameras',
      'AI-Powered Threat Detection',
      'Access Control Systems',
      'Remote Monitoring & Alerts',
      'Scalable Security Solutions'
    ],
    procedure: [
      'Initial Security Assessment',
      'System Design & Planning',
      'Installation & Configuration',
      'Testing & Training',
      'Ongoing Monitoring & Support'
    ],
    faqs: [
      {
        id: 1,
        heading: 'What types of security systems do you offer?',
        content: 'We provide CCTV surveillance, access control, alarm systems, and AI-based threat detection solutions.'
      },
      {
        id: 2,
        heading: 'Can the surveillance system be monitored remotely?',
        content: 'Yes, our systems support remote monitoring via secure apps and web portals.'
      },
      {
        id: 3,
        heading: 'Do you offer customized security solutions?',
        content: 'Absolutely, we tailor our security solutions to match the specific needs of your business.'
      },
      {
        id: 4,
        heading: 'Is training provided for system usage?',
        content: 'Yes, we provide comprehensive training to ensure your team can effectively operate the security systems.'
      }
    ]
  },
  {
    id: 5,
    image: images.service5,
    title: 'Computer Vision',
    content: 'Cutting-edge computer vision solutions that enable machines to interpret and understand visual data for smarter automation and insights.',
    paragraphs: [
      'Our Computer Vision services leverage AI to analyze images and videos, enabling applications like object detection, facial recognition, and quality inspection.',
      'We build tailored solutions to automate visual tasks, improve accuracy, and enhance operational efficiency across industries such as manufacturing, retail, and security.'
    ],
    gallery: [
      images.service5Gallery1,
      images.service5Gallery2,
    ],
    features: [
      'Object Detection & Recognition',
      'Facial Recognition Systems',
      'Real-Time Video Analysis',
      'Quality Control Automation',
      'Custom Vision Model Training'
    ],
    procedure: [
      'Requirement Analysis',
      'Data Collection & Annotation',
      'Model Development & Training',
      'Integration & Deployment',
      'Performance Monitoring & Optimization'
    ],
    faqs: [
      {
        id: 1,
        heading: 'What applications can benefit from computer vision?',
        content: 'Applications include quality inspection, security surveillance, retail analytics, autonomous vehicles, and more.'
      },
      {
        id: 2,
        heading: 'Do you provide custom computer vision models?',
        content: 'Yes, we develop and train custom models tailored to your specific use case and data.'
      },
      {
        id: 3,
        heading: 'How is the visual data processed securely?',
        content: 'We follow best practices for data security, ensuring all images and videos are handled with strict confidentiality.'
      },
      {
        id: 4,
        heading: 'Can your solutions integrate with existing systems?',
        content: 'Absolutely, our computer vision solutions are designed to seamlessly integrate with your current infrastructure.'
      }
    ]
  },
  {
    id: 6,
    image: images.service6,
    title: 'Healthcare Solutions',
    content: 'Innovative AI-driven healthcare solutions to improve diagnostics, patient care, and operational efficiency in medical institutions.',
    paragraphs: [
      'Our Healthcare Solutions harness AI technologies to assist in medical imaging analysis, predictive diagnostics, personalized treatment plans, and patient monitoring.',
      'We aim to empower healthcare providers with tools that enhance accuracy, reduce workload, and improve patient outcomes while maintaining data privacy and compliance.'
    ],
    gallery: [
      images.service6Gallery1,
      images.service6Gallery2,
    ],
    features: [
      'AI-Powered Diagnostics',
      'Predictive Health Analytics',
      'Remote Patient Monitoring',
      'Personalized Treatment Recommendations',
      'Data Security & Compliance'
    ],
    procedure: [
      'Consultation & Needs Assessment',
      'Data Integration & Processing',
      'AI Model Development',
      'Implementation & Training',
      'Ongoing Support & Optimization'
    ],
    faqs: [
      {
        id: 1,
        heading: 'How can AI improve healthcare services?',
        content: 'AI helps by providing faster, more accurate diagnoses, predicting health risks, and enabling personalized patient care.'
      },
      {
        id: 2,
        heading: 'Is patient data secure with your solutions?',
        content: 'Yes, we ensure full compliance with healthcare data regulations like HIPAA to protect patient privacy.'
      },
      {
        id: 3,
        heading: 'Can your solutions integrate with existing hospital systems?',
        content: 'Our healthcare AI solutions are designed for smooth integration with various medical record and hospital management systems.'
      },
      {
        id: 4,
        heading: 'What kind of healthcare data do you work with?',
        content: 'We work with medical imaging, patient records, sensor data, and other health-related datasets.'
      }
    ]
  }

];

export default services;